const agentQuoteStatus = {
    DISABLED : 0,

    ENABLED : 1,

    FORCE_DISABLED : 11,

    QUOTE_ENABLED : 256,

    BIND_ENABLED : 512

};

angular.module('gw-um-j2js')
    .constant('agentQuoteStatus', agentQuoteStatus);